module.exports = __webpack_public_path__ + "static/media/comp3.a1c36fc0.png";